import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import Loading from "../../Loading";
import MomentLocaleUtils, {formatDate, parseDate} from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";

class BPContestEditByFWDStaff extends Component{


    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            id:'',
            name:'',
            startDate:null,
            endDate:null,
            closeDate:null,
            closeConfirmDate:null,
            memoId:'',
            memoFileName:'',
            memoFilePath:'',
            status:'',
            remark:'',
            bankCode:'',
            createdBy:'',
            updatedBy:'',
            createdDate:'',
            updatedDate:'',
        }
        this.state = {
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
            isStartDateEmpty: false,
            isStartDateValid: false,
            isStartDateDisabled: false,
            isEndDateEmpty: false,
            isEndDateValid: false,
            isEndDateDisabled: false,
            isCloseDateEmpty: false,
            isCloseDateValid: false,
            isCloseDateDisabled: false,
            isCloseConfirmDateEmpty: false,
            isCloseConfirmDateValid: false,
            isCloseConfirmDateDisabled: false,
            selectedFile: null,
            isSelectedFile: false,
        }
        this.getContest = this.getContest.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCloseDateChange = this.handleCloseDateChange.bind(this);
        this.handleCloseConfirmDateChange = this.handleCloseConfirmDateChange.bind(this);
        this.handleMemoIdChange = this.handleMemoIdChange.bind(this);
    }
    componentDidMount() {
        this.getContest(this.props?.id);
    }

    onFileChange(e) {
        this.setState({ selectedFile: e.target.files[0], isSelectedFile: true });

    };

    handleSubmit(){
        const {item, selectedFile, isSelectedFile,
            isStartDateEmpty,isEndDateEmpty,isCloseDateEmpty,isCloseConfirmDateEmpty,
            isStartDateValid,isEndDateValid,isCloseDateValid,isCloseConfirmDateValid} = this.state
        let isValidForm = false;
        if(item?.status === 'COMPLETED'){
            this.setState({errorMessage:'Không được phép cập nhật do chương trình đã kết thúc !'});
            return;
        }
        if(item?.name === ''){
            this.setState({errorMessage:'Tên thi đua không được rỗng'});
            return;
        }
        if(isStartDateEmpty){
            this.setState({errorMessage:'Ngày bắt đầu không được rỗng'});
            return;
        }
        if(isEndDateEmpty){
            this.setState({errorMessage:'Ngày kết thúc không được rỗng'});
            return;
        }
        if(isCloseDateEmpty){
            this.setState({errorMessage:'Ngày chốt kết quả không được rỗng'});
            return;
        }
        if(isCloseConfirmDateEmpty){
            this.setState({errorMessage:'Ngày đóng nhận phản hồi không được rỗng'});
            return;
        }
        if(item?.memoId === '' || item?.memoId.trim().length === 0){
            this.setState({errorMessage:'Mã Memo không được rỗng'});
            return;
        }

        if(!isStartDateValid){
            this.setState({errorMessage:'Ngày băt đầu không hợp lệ'});
            return;
        }
        if(!isEndDateValid){
            this.setState({errorMessage:'Ngày kết thúc không hợp lệ'});
            return;
        }
        if(!isCloseDateValid){
            this.setState({errorMessage:'Ngày chốt kết quả không hợp lệ'});
            return;
        }
        if(!isCloseConfirmDateValid){
            this.setState({errorMessage:'Ngày đóng nhận phản hồi không hợp lệ'});
            return;
        }
        const startDateNumber = item?.startDate.split('/')[2]+item?.startDate.split('/')[1]+item?.startDate.split('/')[0];
        const endDateNumber = item?.endDate.split('/')[2]+item?.endDate.split('/')[1]+item?.endDate.split('/')[0];
        const closeDateNumber = item?.closeDate.split('/')[2]+item?.closeDate.split('/')[1]+item?.closeDate.split('/')[0];
        const closeConfirmDateNumber = item?.closeConfirmDate.split('/')[2]+item?.closeConfirmDate.split('/')[1]+item?.closeConfirmDate.split('/')[0];
        if(startDateNumber >= endDateNumber){
            this.setState({errorMessage:'Ngày kết thúc phải lớn hơn ngày bắt đầu'});
            return;
        }

        if(endDateNumber >= closeDateNumber){
            this.setState({errorMessage:'Ngày chốt kết quả phải lớn hơn ngày kết thúc'});
            return;
        }
        if(closeDateNumber >= closeConfirmDateNumber){
            console.log('vo day');
            this.setState({errorMessage:'Ngày đóng nhận phản hồi phải lớn hơn ngày chốt kết quả'});
            return;
        }
        if(isSelectedFile){
            const fileName = selectedFile?.name;
            const fileExtension = fileName.substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName;
            if(fileExtension.toUpperCase() !== 'PDF'){
                this.setState({errorMessage:'Vui lòng chọn tập tin PDF khi tải Memo'});
                return;
            }
        }

        isValidForm = true;
        if(isValidForm === true){
            this.setState({errorMessage:''});
            const formData = new FormData();

            formData.append("id", item?.id);
            formData.append("name", item?.name);
            formData.append("startDate", item?.startDate);
            formData.append("endDate", item?.endDate);
            formData.append("closeDate", item?.closeDate);
            formData.append("closeConfirmDate", item?.closeConfirmDate);
            formData.append("memoId", item?.memoId);
            formData.append("bankCode", item?.bankCode);
            this.setState({isLoading: true});
            if(isSelectedFile) {
                const responseUpdate = axios.post('/api/bankportal/contest/update', formData);
                const formUpload = new FormData();
                formUpload.append("file",selectedFile);
                console.log(responseUpdate);
                console.log(responseUpdate.data);
                const apiUpload = '/api/bankportal/contest/'+item?.id+'/upload';
                console.log('api upload:'+apiUpload);
                const responseUploadMemo = axios.post(apiUpload, formUpload);
                Promise.all([responseUpdate, responseUploadMemo]).then((values) =>{
                    const responseUpdateData = values[0].data;
                    const responseUploadData = values[1].data;
                    console.log(responseUpdateData);
                    if(responseUpdateData != null){
                        this.setState({successMessage: 'Cập nhật thành công',errorMessage:'', isLoading: false});
                        if(responseUploadData == null){
                            this.setState({successMessage: '',errorMessage:'Xảy ra lỗi khi upload Memo !'})
                        }
                    }else{
                        this.setState({successMessage: '',errorMessage:'Xảy ra lỗi khi cập nhật thông tin !'})
                    }
                    this.setState({isLoading: false})
                }).catch(error => {
                    console.error('There was an error!', error);
                    this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
                })
            }else{
                axios.post('/api/bankportal/contest/update', formData)
                    .then(response => {
                        if(response != null){
                            this.setState({successMessage: 'Cập nhật thành công',errorMessage:'', isLoading: false})
                        }else{
                            this.setState({successMessage: '',errorMessage:'Xảy ra lỗi khi cập nhật thông tin !', isLoading: false})
                        }
                    })
                    .catch(error => {
                        console.log(error?.response);
                        this.setState({errorMessage: error?.message,successMessage:'', isLoading: false})
                    })
            }
        }else{
            this.setState({errorMessage: 'Vui lòng kiểm tra lại thông tin !',successMessage:'', isLoading: false})
        }
    }
    getContest(id) {
        this.setState({isLoading: true})
        axios.get('/api/bankportal/contest/'+id+'/load')
            .then((response) =>{
                let item =  response?.data
                if(!!item){
                    this.setState({
                        isStartDateEmpty: false,
                        isStartDateValid: true,
                        isEndDateEmpty: false,
                        isEndDateValid: true,
                        isCloseDateEmpty: false,
                        isCloseDateValid: true,
                        isCloseConfirmDateEmpty: false,
                        isCloseConfirmDateValid: true,
                    })
                    this.setState({ item: item, errorMessage: '',successMessage:'',isLoading: false})
                }else{
                    this.setState({ item: this.state.item, errorMessage: 'Không tìm thấy dữ liệu !',successMessage:'',isLoading: false})
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
            })
    }

    handleStartDateChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        const {item} = this.state;
        item.startDate = formatDate(selectedDay, 'DD/MM/YYYY');
        this.setState({
            item: item,
            isStartDateEmpty: !input.value.trim(),
            isStartDateValid: typeof selectedDay !== 'undefined',
            isStartDateDisabled: modifiers.disabled === true
        });
    }
    handleEndDateChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        const {item} = this.state;
        item.endDate = formatDate(selectedDay, 'DD/MM/YYYY');
        this.setState({
            item: item,
            isEndDateEmpty: !input.value.trim(),
            isEndDateValid: typeof selectedDay !== 'undefined',
            isEndDateDisabled: modifiers.disabled === true
        });
    }
    handleCloseDateChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        const {item} = this.state;
        item.closeDate = formatDate(selectedDay, 'DD/MM/YYYY');
        this.setState({
            item: item,
            isCloseDateEmpty: !input.value.trim(),
            isCloseDateValid: typeof selectedDay !== 'undefined',
            isCloseDateDisabled: modifiers.disabled === true
        });
    }

    handleCloseConfirmDateChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        const {item} = this.state;
        item.closeConfirmDate = formatDate(selectedDay, 'DD/MM/YYYY');
        this.setState({
            item: item,
            isCloseConfirmDateEmpty: !input.value.trim(),
            isCloseConfirmDateValid: typeof selectedDay !== 'undefined',
            isCloseConfirmDateDisabled: modifiers.disabled === true
        });
    }

    handleMemoIdChange =(e) =>{
        const {item} = this.state;
        item.memoId = e.target.value;
        this.setState({item});
    }

    render() {
        const {item, isLoading,errorMessage, successMessage} = this.state;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'container'}>
                <div>
                    <div>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">CẬP NHẬT CHƯƠNG TRÌNH THI ĐUA</h2>
                        <form>
                            <input type="hidden" value={item?.id} />
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Ngân hàng :</label>
                                <div className="col-sm-9">
                                    {item?.bankCode === 'VCB' && <span>Vietcombank</span>}
                                    {item?.bankCode === 'AGB' && <span>Agribank</span>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Tên thi đua :</label>
                                <div className="col-sm-9">
                                    <span>{item?.name}</span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="startDate">Ngày bắt đầu :</label>
                                <div className="col-sm-9">
                                    <DayPickerInput
                                        value={item.startDate}
                                        onDayChange={this.handleStartDateChange}
                                        selectedDay={item.startDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="DD/MM/YYYY"
                                        placeholder='DD/MM/YYYY'
                                        dayPickerProps={{
                                            selectedDays: item.startDate,
                                            locale: 'vi-VN',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                                        inputProps={{ className: 'form-control' }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="endDate">Ngày kết thúc :</label>
                                <div className="col-sm-9">
                                    <DayPickerInput
                                        value={item.endDate}
                                        onDayChange={this.handleEndDateChange}
                                        selectedDay={item.endDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="DD/MM/YYYY"
                                        placeholder='DD/MM/YYYY'
                                        dayPickerProps={{
                                            selectedDays: item.endDate,
                                            locale: 'vi-VN',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                                        inputProps={{ className: 'form-control' }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="closeDate">Ngày chốt kết quả :</label>
                                <div className="col-sm-9">
                                    <DayPickerInput
                                        value={item.closeDate}
                                        onDayChange={this.handleCloseDateChange}
                                        selectedDay={item.closeDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="DD/MM/YYYY"
                                        placeholder='DD/MM/YYYY'
                                        dayPickerProps={{
                                            selectedDays: item.closeDate,
                                            locale: 'vi-VN',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                                        inputProps={{ className: 'form-control' }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="closeConfirmDate">Ngày đóng nhận phản hồi :</label>
                                <div className="col-sm-9">
                                    <DayPickerInput
                                        value={item.closeConfirmDate}
                                        onDayChange={this.handleCloseConfirmDateChange}
                                        selectedDay={item.closeConfirmDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format="DD/MM/YYYY"
                                        placeholder='DD/MM/YYYY'
                                        dayPickerProps={{
                                            selectedDays: item.closeConfirmDate,
                                            locale: 'vi-VN',
                                            localeUtils: MomentLocaleUtils,
                                        }}
                                        inputProps={{ className: 'form-control' }} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="status">Tình trạng xử lý:</label>
                                <div className="col-sm-9">
                                    <select disabled={true} id="status" className="form-control w-25" value={item?.status}>
                                        <option value="PROCESSING">Đang diễn ra</option>
                                        <option value="WAITING_APPROVAL">Chờ chốt kết quả</option>
                                        <option value="WAITING_FEEDBACK">Chờ phản hồi</option>
                                        <option value="COMPLETED">Kết thúc</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="memoId">Mã Memo:</label>
                                <div className="col-sm-9">
                                    <input type="text" className={'form-control'} onChange={this.handleMemoIdChange} value={item?.memoId} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3">Chọn Memo để tải lên:</label>
                                <div className="col-sm-9">
                                    <input type="file" className={'form-control-file'} onChange={this.onFileChange} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/contest'} className="btn btn-success">Quay về</Link>
                                    {item?.status !== 'COMPLETED' && <button type="button" onClick={this.handleSubmit} className="btn btn-primary ml-1">Cập nhật thi đua</button>}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
export default BPContestEditByFWDStaff;